import * as ActionTypes from './action-types.constants';
export const init = () => {
	return {
		type: ActionTypes.INIT
	}
}

export const message = (data) => {
	return {
		type: ActionTypes.MESSAGE,
		data
	}
}